import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

export default class ReportProduction extends Component {
  render() {
    return (
      <div className="card p-0">
        {! _.isEmpty(this.props.productionList) ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>Session Id</th>
                <th className="hidden-xs-down">Inventory Id</th>
                <th title="Item name - brand - grade">Item Description</th>
                <th className="hidden-xs-down" title="QuickBooksMapping identifier">Item Number</th>
                <th className="hidden-xxs-down">Station</th>
                <th className="hidden-xs-down">Parents Initial Weight</th>
                <th className="hidden-xxs-down">Child Initial Weight</th>
                <th>Quantity</th>
                <th className="hidden-xs-down">Production Date</th>
              </tr>
            </thead>
              {this.props.productionList.map((reportRow,idx) => {
                  return (
                    <tbody key={idx}>
                      <tr>
                        <td><NavLink to={`/session/${reportRow.session}`}>{reportRow.session}</NavLink></td>
                        <td className="hidden-xs-down"><NavLink to={`/inventory/${reportRow.inventory}`}>{reportRow.inventory}</NavLink></td>
                        <td>{reportRow.item_description}</td>
                        <td className="hidden-xs-down">{reportRow.item_number}</td>
                        <td className="hidden-xxs-down">{reportRow.station}</td>
                        <td className="hidden-xs-down">{reportRow.parents_initial_weight}</td>
                        <td className="hidden-xxs-down">{reportRow.child_initial_weight}</td>
                        <td>{reportRow.quantity}</td>
                        <td className="hidden-xs-down">{reportRow.production_date}</td>
                      </tr>
                    </tbody>
                  )
              })}
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for the given filters
          </div>
        }
      </div>
    )
  }
}
